import { useEffect, useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import { conditions, responseValidator } from "helpers";
import { ConditionName } from "interfaces";
import { API, apiCaller } from "../../../../../services";
import { shallowEqual } from "react-redux";

const Gif = (props: { gif: string }) => {
    const { manualQuality, autoQuality, qualityLevels } = useAppSelector(
        ({ controller: { manualQuality, autoQuality, qualityLevels } }) => ({ manualQuality, autoQuality, qualityLevels }),
        shallowEqual
    );

    const [gifLink, setGifLink] = useState<string>("");
    const [gifId, setGifId] = useState<any>(0);

    const handleFilterGif = (links: any[]) => {
        if (conditions(ConditionName.filterLastGif) || conditions(ConditionName.isIOS)) return links[links.length - 1].src;
        else {
            const filteredLinks = links.filter(
                (link: any) =>
                    +link.quality <= +qualityLevels[conditions(ConditionName.isAutoQuality) ? autoQuality ?? manualQuality! : manualQuality!]
            );
            return filteredLinks[filteredLinks.length - 1].src;
        }
    };

    const getGifLinks = async () => {
        const { data, status } = await apiCaller({ url: API().live.gifLinks });
        if (responseValidator(status)) {
            const links = data.gifs.find((gif: any) => gif.id === props.gif).links;
            setGifLink(handleFilterGif(links));
            setGifId(props.gif);
        }
    };

    useEffect(() => {
        if (props.gif && gifId !== props.gif) getGifLinks();
    }, [props.gif, manualQuality]);

    return (
        <div id="player-gif" className="pl-absolute pl-top-0 pl-left-0 pl-w-full pl-h-full pl-flex pl-justify-center pl-items-center">
            <img src={gifLink} />
        </div>
    );
};

export default Gif;
